import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import News from './pages/News';
import NewsPost from './pages/NewsPost';
import NotFound from './pages/NotFound';
import Donated from './pages/Donated';
import CancelDonation from './pages/CancelDonation';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminNewsEditor from './pages/admin/AdminNewsEditor';

// Simple auth context
export const AuthContext = React.createContext(null);

function App() {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing admin session
    const token = localStorage.getItem('adminToken');
    if (token) {
      setAdmin({ token });
    }
    setLoading(false);
  }, []);

  const login = (token) => {
    localStorage.setItem('adminToken', token);
    setAdmin({ token });
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setAdmin(null);
  };

  if (loading) {
    return null;
  }

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
        <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
        <Route path="/news" element={<><Navbar /><News /><Footer /></>} />
        <Route path="/news/:slug" element={<><Navbar /><NewsPost /><Footer /></>} />
        <Route path="/donated" element={<Donated />} />
        <Route path="/canceldonation" element={<CancelDonation />} />
        
        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin" 
          element={admin ? <AdminDashboard /> : <Navigate to="/admin/login" />} 
        />
        <Route 
          path="/admin/news/new" 
          element={admin ? <AdminNewsEditor /> : <Navigate to="/admin/login" />} 
        />
        <Route 
          path="/admin/news/:id" 
          element={admin ? <AdminNewsEditor /> : <Navigate to="/admin/login" />} 
        />
        
        {/* Catch all - 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthContext.Provider>
  );
}

export default App;
